import React from 'react';
import { AppointmentTooltip } from '@devexpress/dx-react-scheduler-material-ui';

interface IProps {}
const ToolTipHeader: React.FC<IProps> = props => {
  return <AppointmentTooltip.Header></AppointmentTooltip.Header>;
};

export default ToolTipHeader;
